import type { FormDefinition } from '@/core/templates/types'

export default {
  title: 'Bewilligung',
  sections: {
    Teilnehmer: {
      fields: [
        { id: 'Teilnehmer.Vorname', control: 'text-or-date' },
        { id: 'Teilnehmer.Nachname', control: 'text-or-date' },
      ],
    },
    Kostenträger: {
      fields: [
        { id: 'Kostenträger.Straße', control: 'text-or-date' },
        { id: 'Kostenträger.Hausnummer', control: 'text-or-date' },
        { id: 'Kostenträger.PLZ', control: 'text-or-date' },
        { id: 'Kostenträger.Ort', control: 'text-or-date' },
        { id: 'Kostenträger.Zeichen', control: 'text-or-date' },
      ],
    },
    Maßnahme: {
      fields: [
        { id: 'Maßnahme.Nummer der Maßnahme', control: 'text-or-date' },
        { id: 'Maßnahme.Maßnahmeinhalt (Gruppenmaßnahme)', control: 'text', dictation: true },
        { id: 'Maßnahme.Maßnahmeinhalt (Einzelmaßnahme)', control: 'text', dictation: true },
        { id: 'Maßnahme.Durchführungsort', control: 'text-or-date' },
        { id: 'Maßnahme.Beginn der Maßnahme', control: 'text-or-date' },
        { id: 'Maßnahme.Ende der Maßnahme', control: 'text-or-date' },
        { id: 'Maßnahme.Zeitlicher Umfang (Kategorie)', control: 'text-or-date' },
        { id: 'Maßnahme.Zeitlicher Umfang (max UE)', control: 'text-or-date' },
      ],
    },
  },
} satisfies FormDefinition
